import { Card } from '@/components/ui/card'
import { Heading } from '@/components/ui/heading'

export default function UsageSpecificationPage() {
  return (
    <Card variant="filled" className="min-h-full">
      <Heading size="md" className="mb-1 text-center">
        使用规范
      </Heading>
    </Card>
  )
}
